import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import DeliveryTimeByCarrierChartSkeleton from './DeliveryTimeByCarrierChartSkeleton/DeliveryTimeByCarrierChartSkeleton'
import * as Styles from './styles'

const DeliveryTimeByCarrierChart = ({ metrics, loading }) => {
  const theme = useTheme()
  const getPercentage = value => {
    const maxValue = metrics[metrics.length - 1]?.average_delivery_time_minutes

    return (value * 100) / maxValue
  }

  const getMinutesInDaysAndHours = minutes => {
    const days = Math.floor(minutes / (24 * 60))
    const hours = Math.floor((minutes % (24 * 60)) / 60)

    return `${days}d ${hours}h`
  }

  if (loading) return <DeliveryTimeByCarrierChartSkeleton />

  return (
    <Styles.Container>
      {metrics?.map((carrier, index) => (
        <Styles.CarrierContainer key={index}>
          <Styles.CarrierPosition>
            <Text type="bodyMRegular" color={theme.colors.text.subtle}>
              {index + 1}
            </Text>
          </Styles.CarrierPosition>
          <Styles.CarrierInfoContainer>
            <Styles.CarrierName>
              <Styles.CarrierLogo src={carrier.carrier_logo_url} alt={carrier.carrier_name} width="24" height="24" />
              <Text type="bodyMBold">{carrier?.carrier_service_name}</Text>
            </Styles.CarrierName>
            <Styles.ProgressBarContainer>
              <Styles.ProgressBar
                animate={{ width: `${getPercentage(carrier.average_delivery_time_minutes)}%` }}
                transition={{ duration: 0.8 }}
              />
              <Styles.DeliveryTimeContainer style={{ width: '100px' }}>
                <Text type="bodyMBold">{getMinutesInDaysAndHours(carrier.average_delivery_time_minutes)}</Text>
              </Styles.DeliveryTimeContainer>
            </Styles.ProgressBarContainer>
          </Styles.CarrierInfoContainer>
        </Styles.CarrierContainer>
      ))}
    </Styles.Container>
  )
}

export default DeliveryTimeByCarrierChart
